// extracted by mini-css-extract-plugin
module.exports = {"circleWrapper":"TexturedCircle_circleWrapper__yzHds","circle":"TexturedCircle_circle__XqumR"};